var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.125 0C1.67525 0 0.5 1.17525 0.5 2.625L0.5 15.375C0.5 16.8247 1.67525 18 3.125 18H12.875C14.3247 18 15.5 16.8247 15.5 15.375V2.625C15.5 1.17525 14.3247 0 12.875 0H3.125ZM2 2.625C2 2.00368 2.50368 1.5 3.125 1.5H5V1.875C5 2.28921 5.33579 2.625 5.75 2.625H10.25C10.6642 2.625 11 2.28921 11 1.875V1.5H12.875C13.4963 1.5 14 2.00368 14 2.625V15.375C14 15.9963 13.4963 16.5 12.875 16.5H3.125C2.50368 16.5 2 15.9963 2 15.375V2.625Z",
    fill: "#777777"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.875 6.5625C3.875 6.04473 4.29473 5.625 4.8125 5.625H11.1875C11.7053 5.625 12.125 6.04473 12.125 6.5625C12.125 7.08027 11.7053 7.5 11.1875 7.5H4.8125C4.29473 7.5 3.875 7.08027 3.875 6.5625Z",
    fill: "#777777"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.875 9.9375C3.875 9.41973 4.29473 9 4.8125 9H11.1875C11.7053 9 12.125 9.41973 12.125 9.9375C12.125 10.4553 11.7053 10.875 11.1875 10.875H4.8125C4.29473 10.875 3.875 10.4553 3.875 9.9375Z",
    fill: "#777777"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.875 13.3125C3.875 12.7947 4.29473 12.375 4.8125 12.375H11.1875C11.7053 12.375 12.125 12.7947 12.125 13.3125C12.125 13.8303 11.7053 14.25 11.1875 14.25H4.8125C4.29473 14.25 3.875 13.8303 3.875 13.3125Z",
    fill: "#777777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetail);
export default __webpack_public_path__ + "static/media/Detail.ac33cb0bc7486473ef9524192c40e2a4.svg";
export { ForwardRef as ReactComponent };